import { render } from "./ProjectViewModal.vue?vue&type=template&id=5a178bce"
import script from "./ProjectViewModal.vue?vue&type=script&lang=js"
export * from "./ProjectViewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__